export { default as CustomPanel } from './src/custom-panel';
